import VAnimateCss from './dist';

export default VAnimateCss;


//////////////////
// WEBPACK FOOTER
// ./~/v-animate-css/index.js
// module id = 217
// module chunks = 0 3